class CustomAtc extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.querySelector('form[action$="/cart/add"]').addEventListener('submit', (e) => {
            e.preventDefault();

            let formData = new FormData(e.target);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                handleFloCartBtn();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        })
    }
}

if (!customElements.get('custom-atc')) {
    customElements.define('custom-atc', CustomAtc);
}